var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBlankReportsView = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 66,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.98 21.77l.02.02h-.02v43.522H0V0h35.786L54.98 19v2.77zm-5.498.02H32.988V5.444H5.498V59.87h43.984V21.79zm-38.486 8.145v-5.443h19.243v5.443H10.996zm0 10.885v-5.442h32.988v5.442H10.996zm0 10.886v-5.443h32.988v5.443H10.996zm27.585-35.38h5.403l-5.403-5.349v5.35z",
    fill: "#BEC8D2",
    fillRule: "nonzero",
    opacity: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBlankReportsView, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/blank_reports_view.0e9ed0e5.svg";
export { ForwardRef as ReactComponent };